// Pure scoring for the archetype quiz — no DOM. See test/archetype-scoring.test.js
export const FAMILIES = ['A', 'B', 'C', 'D'];

/**
 * Tally answers (array of 'A'|'B'|'C'|'D'; other values ignored).
 * family: most-picked; ties go to whichever family reached that count first.
 * secondary: a different family within 1 point of the winner, else null.
 */
export function scoreArchetype(answers) {
  const counts = { A: 0, B: 0, C: 0, D: 0 };
  const reachedAt = { A: -1, B: -1, C: -1, D: -1 };
  (answers || []).forEach(function (v, i) {
    if (FAMILIES.indexOf(v) < 0) return;
    counts[v]++;
    reachedAt[v] = i;
  });

  let family = null;
  FAMILIES.forEach(function (f) {
    if (counts[f] === 0) return;
    if (
      family === null ||
      counts[f] > counts[family] ||
      (counts[f] === counts[family] && reachedAt[f] < reachedAt[family])
    ) {
      family = f;
    }
  });

  let secondary = null;
  FAMILIES.forEach(function (f) {
    if (f === family || counts[f] === 0) return;
    if (counts[family] - counts[f] > 1) return;
    if (
      secondary === null ||
      counts[f] > counts[secondary] ||
      (counts[f] === counts[secondary] && reachedAt[f] < reachedAt[secondary])
    ) {
      secondary = f;
    }
  });

  return { family: family, secondary: secondary, counts: counts };
}
